export default class Nav {
  constructor() {
    this.$currentClickedDropdown = false;

    this.addFocusClassToNavItemsOnFocus();
    this.setupDropdownDoubleTapOnTouch();
    this.activeClassOnBurgerIConClick();
  }

  // For accessibility we need to add focus classes on keyboard focus
  // so that dropdown menus can maintain their visibility when their
  // children are the only active elements
  addFocusClassToNavItemsOnFocus() {
    let focusChain = [];
    let $navElements = $('.nav > li a');

    $navElements.on('focus', (e) => {
      $(e.target).addClass('focus');

      focusChain = focusChain.filter((element) => {
        let isChild = $.contains(element.parentElement, e.target);

        if (!isChild) {
          $(element).removeClass('focus');
        }

        return isChild;
      }).concat([document.activeElement]);
    });

    $('*').not($navElements).on('focus', () => $navElements.filter('.focus').removeClass('focus'));
  }

  // for touch devices: only clickthrough parent elements on double tap
  // so you can easily access the dropdown elements
  setupDropdownDoubleTapOnTouch() {
    if (!this.hasTouch()) return false;

    $('.dropdown-toggle').each((i, el) => {
      const $el = $(el);

      $el.on('click', (e) => {
        if ($el[0] != this.$currentClickedDropdown[0]) {
          e.preventDefault();
          this.$currentClickedDropdown = $el;
        }
      });
    });
  }

  // basic check for touch behaviour
  hasTouch() {
    if( ( 'ontouchstart' in window ) ||
      navigator.msMaxTouchPoints ||
      navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) {
        return true;
    }

    return false;
  }

  activeClassOnBurgerIConClick() {
    $('.burger-menu').on('click', function(){
      $('body').toggleClass('nav-show');
    })
  }
}





// WEBPACK FOOTER //
// ./scripts/lib/Nav.js